module.exports = __webpack_public_path__ + "static/media/FileIcon.ebeb6d3b.svg";